
import {Component, Prop, Vue} from "vue-property-decorator";
import {regex, formRules} from "@/utils/formRules";
import {Getter} from "vuex-class";
import Telephone from "@/components/Telephone.vue";
import MylobyAutocompleteMultiple from "../generic/autocomplete-multiple.vue";

@Component({
    components: {
        Telephone,
        MylobyAutocompleteMultiple,
    },
})
export default class AddContact extends Vue {

    @Prop({default: null})
    public companyId: number;

    @Getter private isMobile: boolean;
    private rules: any = formRules;
    private showDialog: boolean = false;
    private newContact: any = {};
    private valid: boolean = true;
    private loading: boolean = false;

    private init(): void {
        this.newContact = {};
        this.showDialog = false;
        this.loading = false;
        const refForm: any = this.$refs.form;
        refForm.reset();
    }

    private addContact(): void {
        if (!this.newContact.email && this.newContact.phone) {
            this.newContact.email = this.newContact.phone;
        }

        this.loading = true;
        this.$store.dispatch("companies/addContact", {
            companyId: this.companyId,
            contact: this.newContact,
        }).then((res) => {
            this.$store.commit("alerts/displaySuccess", {
                msg: this.$t("contacts.added", {
                    contactEmail: this.newContact.email,
                }),
            });
            this.$emit("reset");
            this.init();
        }).catch((error) => {
          this.$store.commit("alerts/displayHttpError", { error });
        }).finally(() => {
          this.loading = false;
        });
    }

    private validEmail(email): boolean {
        return formRules.isEmail(email);
    }

    private validPhoneNumber(phone): boolean {
        return regex.validPhoneNumber.test(phone);
    }

    private fetchContactGroups({search, page, itemsPerPage}: { search: string, page: number, itemsPerPage: number },
    ): Promise<{ count: number; rows: any[] }> {
        return this.$store.dispatch("companies/getUserGroups", {
            id: this.companyId,
            query: {
            search,
            page,
            itemsPerPage,
            type: "contacts",
            excludeScoped: true,
            },
        }).then((data) => ({ count: data.count, rows: data.list }));
    }
}
